import { AlphabetPiqadIcon } from './AlphabetPiqadIcon';

/**
 * author: Haley Halcyon
 * id 169593B8-F579-4167-B49C-5F353BBABB00
 * name alphabet-piqad
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-piqad.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemPiqadIcon = AlphabetPiqadIcon;
export default WritingSystemPiqadIcon